<!--
 * 秒杀活动 Banner 组件 (完全还原小程序 detailswipericon 样式)
-->
<template>
  <div v-if="seckillSku" class="miaosha_bg_box">
    <!-- 秒杀的背景图 -->
    <img :src="bgImg" class="miaosha_bg_img" alt="miaosha_bg" />
    
    <!-- 秒杀相关内容 -->
    <div class="miaosha_content">
      <!-- 秒杀价格 -->
      <div class="miaosha_content_jiage_box">
        <div class="price_zhu font_weight600 colof">
          <span class="currency_symbol">{{ currencySymbol }}</span>
          <span class="price_num">{{ displayPrice }}</span>
        </div>
        <div v-if="displayCrossedPrice" class="crossed_price font12">
          {{ currencySymbol }}{{ displayCrossedPrice }}
        </div>
      </div>

      <!-- 秒杀限购数量 -->
      <div
        v-if="seckillSku.seckillStock"
        class="font10 miaosha_content_xiangou_box"
      >
        限{{ seckillSku.seckillStock }}件
      </div>

      <!-- 秒杀标识图标 (限时秒杀艺术字) -->
      <img
        src="@/assets/miaosha/misosha_shangxiang_msbg_miaosha.png"
        class="miaosha_bg_img_icon"
        alt="miaosha_icon"
      />

      <!-- 秒杀倒计时 -->
      <div class="miaosha_content_daojishi_box">
        <div class="title_box_left_box">
          <van-count-down :time="countDownTime" @finish="onFinish">
            <template #default="timeData">
              <span class="item font10">{{ padZero(timeData.hours) }}</span>
              <span class="maohao">:</span>
              <span class="item font10">{{ padZero(timeData.minutes) }}</span>
              <span class="maohao">:</span>
              <span class="item font10">{{ padZero(timeData.seconds) }}</span>
            </template>
          </van-count-down>
          <div class="title_box_end font10">
            {{ seckillStatus === 1 ? "结束" : "开始" }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import bgOngoing from "@/assets/miaosha/misosha_shangxiang_msbg_11_23_08_21.png";
import bgUpcoming from "@/assets/miaosha/misosha_shangxiang_msbg_01_23_08_21.png";

export default {
  name: "MiaoshaBanner",
  computed: {
    currencySymbol() {
      return (this.$G && this.$G("symbol")) || "$";
    },
    mallretailspu() {
      return this.$store.getters.mallretailspu || {};
    },
    seckillSku() {
      if (!this.mallretailspu || Object.keys(this.mallretailspu).length === 0) {
        return null;
      }
      // 1. 优先读取显式 seckillSku / seckillInfo 结构
      let sku =
        this.mallretailspu.seckillSku ||
        (this.mallretailspu.titleInfo &&
          this.mallretailspu.titleInfo.showSkusInfo &&
          this.mallretailspu.titleInfo.showSkusInfo.seckillSku) ||
        this.mallretailspu.seckillInfo ||
        this.mallretailspu.seckill;

      if (sku) return sku;

      // 2. 判断是否存在秒杀活动标记字段
      const spu = this.mallretailspu;
      if (
        spu.isSeckill === 1 ||
        spu.isSeckill === true ||
        spu.seckillPrice ||
        spu.seckillStatus !== undefined ||
        spu.seckillId ||
        (spu.titleInfo && spu.titleInfo.seckillSku)
      ) {
        return {
          status: spu.seckillStatus ?? spu.status ?? 1,
          remainingTime:
            spu.remainingTime ?? spu.seckillRemainingTime ?? 21839000,
          seckillStock: spu.seckillStock ?? spu.userQuotaNum ?? 100,
          seckillPrice: spu.seckillPrice || spu.finalPrice || spu.storePrice,
          clientPrice: spu.clientPrice || spu.crossedPrice
        };
      }

      // 3. 检查子 sku 中是否有秒杀标记
      if (spu.skus) {
        for (const key in spu.skus) {
          const item = spu.skus[key];
          if (item && (item.seckillSku || item.isSeckill || item.seckillPrice)) {
            return (
              item.seckillSku || {
                status: item.seckillStatus ?? 1,
                remainingTime: item.remainingTime ?? 21839000,
                seckillStock: item.seckillStock ?? 100,
                seckillPrice: item.seckillPrice || item.storePrice,
                clientPrice: item.crossedPrice || item.clientPrice
              }
            );
          }
        }
      }

      return null;
    },
    seckillStatus() {
      if (!this.seckillSku) return 1;
      return Number(this.seckillSku.status) === 0 ? 0 : 1;
    },
    bgImg() {
      return this.seckillStatus === 1 ? bgOngoing : bgUpcoming;
    },
    displayPrice() {
      if (!this.seckillSku) return "0.00";
      const price =
        this.seckillSku.seckillPrice ||
        this.mallretailspu.finalPrice ||
        this.mallretailspu.storePrice ||
        this.mallretailspu.price ||
        0;
      return Number(price).toFixed(2);
    },
    displayCrossedPrice() {
      if (!this.seckillSku) return "";
      const price =
        this.seckillSku.clientPrice ||
        this.seckillSku.originalPrice ||
        this.mallretailspu.clientPrice ||
        this.mallretailspu.crossedPrice;
      return price ? Number(price).toFixed(2) : "";
    },
    countDownTime() {
      if (!this.seckillSku || !this.seckillSku.remainingTime) return 21839000;
      return Math.max(0, Number(this.seckillSku.remainingTime));
    }
  },
  methods: {
    padZero(val) {
      if (val === undefined || val === null) return "00";
      const n = Number(val);
      return n < 10 ? `0${n}` : `${n}`;
    },
    onFinish() {
      this.$emit("countDownFinish");
    }
  }
};
</script>

<style lang="less" scoped>
.miaosha_bg_box {
  position: relative;
  width: calc(100% + 20px);
  margin-left: -10px;
  margin-right: -10px;
  height: 87px;
  margin-bottom: -20px;
  box-sizing: border-box;
  overflow: hidden;
  z-index: 1;
}

.miaosha_content,
.miaosha_bg_img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.miaosha_bg_img {
  object-fit: cover;
}

.miaosha_content_jiage_box {
  position: absolute;
  left: 12px;
  top: 14px;
  display: flex;
  gap: 6px;
  align-items: flex-end;
  color: #ffffff;

  .price_zhu {
    color: #ffffff;
    display: flex;
    align-items: baseline;

    .currency_symbol {
      font-size: 16px;
      font-weight: bold;
      margin-right: 1px;
    }

    .price_num {
      font-size: 24px;
      font-family: D-DIN, DIN-Bold, sans-serif;
      font-weight: 700;
      line-height: 1;
    }
  }

  .crossed_price {
    color: rgba(255, 255, 255, 0.65);
    text-decoration: line-through;
    font-size: 12px;
    margin-bottom: 2px;
  }
}

.miaosha_content_xiangou_box {
  position: absolute;
  left: 12px;
  top: 41px;
  background: rgba(255, 255, 255, 0.25);
  border-radius: 111px;
  padding: 0 7px;
  height: 16px;
  line-height: 16px;
  color: #ffffff;
  font-size: 10px;
}

.miaosha_bg_img_icon {
  position: absolute;
  right: 15px;
  top: 10px;
  width: 78px;
  height: 31px;
}

.miaosha_content_daojishi_box {
  position: absolute;
  right: 15px;
  top: 39px;
}

.title_box_left_box {
  display: flex;
  align-items: center;
}

.item {
  display: inline-flex;
  flex-direction: row;
  color: #ffffff;
  text-align: center;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.25);
  justify-content: center;
  align-items: center;
  font-family: D-DIN, DIN-Bold, sans-serif;
  font-weight: 700;
  font-size: 10px;
}

.title_box_end {
  font-weight: 500;
  font-family: PingFang SC, sans-serif;
  color: #ffffff;
  font-size: 10px;
  margin-left: 3px;
}

.maohao {
  font-weight: 500;
  color: #ffffff;
  font-family: PingFang SC, PingFang SC-Medium, sans-serif;
  padding: 0 4px;
  margin-left: -2px;
}
</style>

